'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './ballot-edit.routes';

export class BallotEditComponent {
  constructor(BallotsService, Auth, $state, dialogs, $stateParams, $uibModal, StorageService, VotingsService, $location, $window, $sce) {
    'ngInject';

    this.BallotsService = BallotsService;
    this.StorageService = StorageService;
    this.VotingsService = VotingsService;
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$state = $state;
    this.ballotId = $stateParams.id;
    this.voteId = $stateParams.voteId;
    this.$location = $location;
    this.$sce = $sce;

    this.back = ($event) => {
      $event.preventDefault();
      $window.history.back();
    };

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["insertImage", "insertLink"]
    ];

    this.ballot = {
      responses: [],
      name: "",
      description: "",
      secret: false,
      rules: {
        minResponses: 1,
        maxResponses: 1
      },
      meta: {
        creationUser: Auth.getCurrentUserSync()._id
      }
    };

    if (this.ballotId) {
      this.BallotsService.get({id: this.ballotId}, ballot => {
        this.ballot = ballot;
        this.ballot.responses = ballot.responses.map(response => { return {name: response} });
        this.loadForm();

        if (this.ballot.attachment) {
          this.getAttachmentFilename();
        }
      }, _ => console.log("Could not load ballot from server"));
    } else {
      this.loadForm();
    }
  }

  removeAttachment() {
    delete this.ballot.attachment;
    delete this.attachmentFilename;
  }


  validationFailed() {
    let failed = false;
    let reasons = [];

    this.failedHtml = "";

    if (!this.ballot.name) {
      reasons.push("Name of Ballot");
      failed = true;
    }

    if (!this.ballot.rules || typeof this.ballot.rules.minResponses !== 'number') {
      reasons.push("Minimum Number of Responses");
      failed = true;
    }

    if (!this.ballot.rules || typeof this.ballot.rules.maxResponses !== 'number') {
      reasons.push("Maximum Number of Responses");
      failed = true;
    }

    if (!this.ballot.responses.length > 0 || !this.ballot.responses[0].name || !this.ballot.responses[0].name.trim() === '') {
      reasons.push("At least one response");
      failed = true;
    }

    if (failed) {
      let html = "Please enter all <b>required fields</b>: <ul style='padding-top:8px'>";
      reasons.forEach(reason => html += "<li>" + reason + "</li>");
      html += "</ul>";

      this.failedHtml = this.$sce.trustAsHtml(html);
    }

    return failed;
  }


  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result && result.length > 0) {
          that.ballot.attachment = result[0];
          that.getAttachmentFilename();
        }

      },
      function () { /* cancel */ }
    );

  }

  getAttachmentFilename() {
    this.StorageService.getMeta({id: this.ballot.attachment}, meta => {
      this.attachmentFilename = meta.filename;
    })
  }

  loadForm() {

    this.schema= {
      type: "object",
      properties: {
        responses: {
          "type": "array",
          "title": "Responses",
          "items": {
            "type": "object",
            "properties": {
              "name": {
                type: "string"
              }
            }
          }
        }
      }
    };

    this.form = [{
      key: "responses",
      title:"Responses",
      add: "Add Response",
      items: [{
        type: "string",
        key: "responses[].name",
        title:"Response"
      }]
    }];

    /*
    this.schema = {
      type: "object",
      properties: {
        name: {
          type: "string",
          title: "Name / Headline of the Ballot"
        },
        description: {
          type: "string",
          title: 'Description of the Ballot'
        },
        secret: {
          title: "Secret Vote",
          type: "boolean"
        },
        rules: {
          "title": "Rules",
          "type": "object",
          "properties": {
            "minResponses": {
              "title": "Minimum Number of Responses Allowed",
              type: "number"
            },
            "maxResponses": {
              "title": "Maximum Number of Responses Allowed",
              type: "number"
            }
          }
        },
        responses: {
          "type": "array",
          "title": "Responses",
          "items": {
            "type": "object",
            "properties": {
              "name": {
                type: "string"
              }
            }
          }
        }
      }
    };

    this.form = [
      {
        "type": "tabs",
        "tabs": [
          {
            "title": "Simple stuff",
            "items": [

          "name", {
          key:"description",
            type: "textarea"
          }
          ]},
      {

        "title": "Secret Vote",
        "items": [
          "secret"]
      },
      {

        "title": "Responses",
        "items": [
          {
            key: "responses",
            title:"Responses",
            add: "Add another response",
            items: [{
              type: "string",
              key: "responses[].name",
              title:"Response"
            }]
          }
        ]
      }, {
          "title": "Rules",
            "items": [ "rules",
              {
                "type": "fieldset",
                "title": "Attachment",
                "items": []
              }]
        }]}];*/
    /*this.form = [
      {
        "type": "fieldset",
        "title": "General",
        "items": [
          "name", {
          key:"description",
            type: "textarea"
          }
          ]},
      {
        "type": "fieldset",
        "title": "Secret Vote",
        "items": [
          "secret"]
      },
      {
          "type": "fieldset",
        "title": "Responses",
        "items": [
          {
            key: "responses",
            title:"Responses",
            add: "Add another response",
            items: [{
              type: "string",
              key: "responses[].name",
              title:"Response"
            }]
          }
        ]
      },
      "rules",
      {
        "type": "fieldset",
        "title": "Attachment",
        "items": []
      }
    ];*/
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = (newBallot) => {

        if (this.ballotId) {
          var dlg = this.dialogs.notify("Success", "The ballot has been edited successfully");
          dlg.result.then(() => {
            that.$location.url("/voting/edit/"+that.voteId);
          });
        } else {
          this.VotingsService.patch({id: this.voteId}, [{
            op: "add",
            path: "/ballots/-",
            value: newBallot._id
          }], _=> {
            var dlg = this.dialogs.notify("Success", "The ballot has been created successfully");
            dlg.result.then(() => {
              that.$location.url("/voting/edit/"+that.voteId);
            });
          },err=>{
            //TODO: some meaningful stuff here
            alert(err);
          })
        }
      };

      var onError = err => {
        this.sendFailure = true;
      };

      let ballot = angular.copy(this.ballot);
      ballot.responses = this.ballot.responses.map(obj => obj.name);

      if (this.ballotId) {
        this.BallotsService.update({id: this.ballot._id}, ballot, onSuccess, onError);
      } else {
        this.BallotsService.save(ballot, onSuccess, onError);
      }

    }
  }
}

export default angular.module('conduu.ballotsEdit', [uiRouter])
  .config(routes)
  .component('ballotsEdit', {
    template: require('./ballot-edit.html'),
    controller: BallotEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/ballot/ballot-edit/ballot-edit.component.js